import { useQuery } from '@tanstack/react-query'
import { topBulkPurchaseTitlesKeys } from '@!/Api/queryKeys'
import { getTopBulkPurchaseTitlesApi } from '@!/Api/bulkPurchaseTitles'
import { useAtom } from 'jotai'
import { safeSearchAtom } from '@!/atoms/safeSearchAtom'

export const useTopBulkPurchaseTitles = (genreTabName) => {
  const [safeSearch] = useAtom(safeSearchAtom)

  const { data } = useQuery({
    queryKey: topBulkPurchaseTitlesKeys.filtered(safeSearch),
    queryFn: async () => {
      return await getTopBulkPurchaseTitlesApi(safeSearch)
    },
    enabled: genreTabName === null || genreTabName === undefined, // ジャンルタブ未選択時のみ有効化
    refetchOnWindowFocus: false,
  })

  return data || []
}
